
import React, { Component, Text, useState, useRef, useEffect, useContext } from 'react'
import '../../../CSS/BookAServiceWithus.css'
import { Navbar, NavbarBrand, Nav, NavItem, Row, NavbarToggler,ModalBody, Collapse, Col, Modal, FormGroup, Input, Button, FormFeedback, NavLinkReactor } from 'reactstrap';
import { isAndroid, isIOS } from 'react-device-detect';
import redirectBannerCrossIcon from '../../../Assets/icons-closeModal.png'
import { AiFillCloseCircle } from "react-icons/ai";

export default function BookAserviceWithUs(props) {
     let [redirectBannerModal, setRedirectBannerModal] = useState(false)
     let [proClick, setProClick] = useState(false)

     const handleBookService = () => {
        console.log('isAndroid', isAndroid,isIOS)

        if(!isAndroid&&!isIOS){
            setRedirectBannerModal(true)
            setProClick(false)
            return;
        }
        else{
            const url = isAndroid?'https://play.google.com/store/apps/details?id=com.quickfinduser&utm_campaign=Consumer_Guide&utm_source=Website&utm_medium=DigitalMarketingSources':'https://apps.apple.com/us/app/slash-consumer/id1489207325?ls=1/?utm_campaign=Consumer_Guide&utm_source=Website&utm_medium=DigitalMarketingSources'
            window.location.href = url
        }
    }
    const handleJoinAaPro = () => {
        if(!isAndroid&&!isIOS){
            setRedirectBannerModal(true)
            setProClick(true)
            return;
        }else{
            const url = isAndroid?'https://play.google.com/store/apps/details?id=com.quickfindmerchant&utm_campaign=Merchant_Guide&utm_source=Website&utm_medium=DigitalMarketingSources':'https://apps.apple.com/us/app/slash-merchant/id1489211413?ls=1/?utm_campaign=Merchant_Guide&utm_source=Website&utm_medium=DigitalMarketingSources'
            window.location.href = url
        } 
    }
    return (<>
        <div className="booking-service-with-us-container">
            <div className="booking-service-with-us-overlay">
                <h1 className="booking-service-with-us-title">
                    Ready to <span>{props.fromPro ? 'Join us' : 'Book a service with us?'}</span>
                </h1>
                <p className="booking-service-with-us-subtitle">
                    Get started in minutes — or join us as a professional to grow your business.
                </p>
                <div className="booking-service-with-us-button-group">
                    <button
                        className="booking-service-with-us-btn-primary"
                        onClick={handleBookService}
                    >
                        <text className="booking-service-with-us-btn-primary-text">
                            Book a service <span>→</span>
                        </text>
                    </button>
                    <button className="booking-service-with-us-btn-secondary"
                        onClick={handleJoinAaPro}
                    >
                        <text className="booking-service-with-us-btn-secondary-text">   
                            Join as a professional <span>→</span>
                        </text>
                    </button>
                </div>
            </div>
        </div>

        <Modal isOpen={redirectBannerModal} style={{ borderRadius: 25 }} size='lg'>
            <ModalBody style={{ borderRadius: 25 }}>
                <div style={{ position: 'absolute', right: 32, top: 20 }} className='crossIcon_ViewPro' onClick={() => { setRedirectBannerModal(false) }}>
                    <AiFillCloseCircle size={30}/>
                    
                </div>
                <div style={{ width: '100%', height: '100%', borderRadius: 25 }}>
                    {proClick?
                        <img src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1781689065239-lg.png'} style={{ width: '100%', height: '100%', borderRadius: 25 }} />
                        :
                         <img src={'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1781688480606-lg.png'} style={{ width: '100%', height: '100%' }} />

                    }
                </div>
            </ModalBody>
        </Modal>

    </>
    )
}
